import React, {useEffect} from 'react';
import MetaTags from "../components/MetaTags";

const Vosmerka: React.FC = () => {
    useEffect(() => {
        document.title = "Сетчатое плетение";
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", "Новое описание страницы");
        }
    }, []); // Пустой массив зависимостей означает, что эффект выполнится только один раз при монтировании компонента

    MetaTags(
        "Сетчатое плетение",
        "Схемы плетения треугольной цепочки и восьмерки из бисера. Треугольная - ажурная и простая в плетении. Восьмерка эффектная, можно создать множество узоров."
    )

    return <>
        <h2>Треугольная цепочка</h2>
        <p>Эта ажурная цепочка очень простая в плетении.</p>
        <p>Надеваем на леску 7 бисеринок, продеваем леску в первую и затягиваем колечко (рис.А). Набираем на леску еще 4
            бисеринки и протягиваем ее через 6ю (рис.Б).
            Затем набираем еще 4 бисеринки и пропускаем леску через 10-ю (рис.В). И так далее продолжаем плести до
            нужной длины.</p>

        <img src="/image/Schema/treougolnaya.jpg" width="550" height="200"
             className="schema col-centered img-responsive" alt="Схема плетения треугольной цепочки"/>
        <h2>Восьмерка</h2>
        <p>На этой цепочке можно выплетать множество разнообразных узоров, она очень эффектная. Плетется в одну
            нить.</p>

        <p>Набираем 11 бисеринок и продеваем леску в 5-ю (рис.А). Набираем еще 3 бисеринки и протягиваем леску через
            1-ю, затем набираем еще 4 и продеваем леску через 13-ю бисеринку (рис.Б).
            Продолжаем плести далее, как показано на рисунке В. Средняя из 3-х бисеринок и третья из 4-х всегда будет
            связующей.</p>

        <img src="/image/Schema/vosmerka.jpg" width="550" height="214" className="schema col-centered img-responsive"
             alt="Схема плетения восьмерки"/>
        <p>Вот несколько вариантов узоров для такой цепочки.</p>

        <img src="/image/Schema/ouzor8.jpg" width="550" height="738"
             className="schema img-thumbnail col-centered img-responsive" alt="Браслеты на основе восьмерки"/>

    </>;
};

export default Vosmerka;

